import { render } from "./SiteSwitcher.vue?vue&type=template&id=8a86e6a4&scoped=true"
import script from "./SiteSwitcher.vue?vue&type=script&lang=js"
export * from "./SiteSwitcher.vue?vue&type=script&lang=js"

import "./SiteSwitcher.vue?vue&type=style&index=0&id=8a86e6a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a86e6a4"]])

export default __exports__